import axios from 'axios';
import toast from 'react-hot-toast';
import { Button } from '@mui/material';
import { startLoading, stopLoading } from '../contexts/loadingIndicatorContext.js';
// axios.defaults.withCredentials = true; // useless, kept if it messed up something that I don't know

/**
 * Request interceptor to increment loading counter
 */
axios.interceptors.request.use(
    (config) => {
        startLoading();
        return config;
    },
    (error) => {
        stopLoading();
        return Promise.reject(error);
    }
);

/**
 * Response interceptor for error handling and decrementing loading counter
 */
axios.interceptors.response.use(
    response => {
        stopLoading();
        return response;
    },
    error => {
        stopLoading();

        // toast notifications for different error
        switch (error.response?.status) {
            case 502:
                toast.error(
                    <>
                        Le serveur n'a pas répondu, essayez dans quelques secondes.
                        <Button onClick={() => window.location.reload()}>Se reconnecter</Button>
                    </>
                );
                break;
            case 401:
                toast.error(
                    <>
                        Vous n'êtes pas connecté ou votre connexion a expiré.
                        <Button onClick={() => window.location.reload()}>Se reconnecter</Button>
                    </>
                );
                break;
            case 403:
                toast.error(
                    <>
                        Vous n'êtes pas habilité à accéder à cette ressource.
                        <Button onClick={() => window.location.reload()}>Se reconnecter</Button>
                    </>
                );
                break;
            case 404:
                toast.error('Cette ressource est introuvable.');
                break;
            default:
                toast.error(`Erreur dans la requête: ${error.response?.status || 'Inconnue'}`);
                console.error('Axios response error:', {
                    status: error.response?.status,
                    response: error.response,
                });
                break;
        }

        return Promise.reject(error); // Propagate error for further handling
    }
);

export default axios;